function getMagicLinks() {
  const res = [
    {
      name: '>4 & <4 preflop',
      path: '/solutions',
      query: 'preflop_actions=F-F-F-R2.2-F&gametype=Cash6m500zGeneral&depth=50&history_spot=4',
    },
    {
      name: '<6 postflop',
      path: '/solutions',
      query:
        'gametype=Cash6m500zBasic&depth=100&soltab=strategy&history_spot=7&preflop_actions=F-F-F-R2.5-F-C&flop_actions=X&board=QsTs7h',
    },
    {
      name: '>6 postflop',
      path: '/solutions',
      query:
        'gametype=Cash6m50zComplex&depth=100&soltab=strategy&history_spot=7&preflop_actions=F-F-R2.5-F-F-C&board=QsTs7h&flop_actions=X',
    },
    {
      name: 'zero_frequency_line spot',
      path: '/solutions',
      query:
        'gametype=Cash6m500zBasic&depth=100&history_spot=3&gmff_depth=100&gmff_type=basic&gmfft_sort_key=0&gmfft_sort_order=desc&preflop_actions=F-F-RAI',
    },
    {
      name: 'reports - flop <6actions',
      path: '/solutions',
      query:
        'gametype=Cash6m500zBasic&depth=100&soltab=reports&history_spot=7&preflop_actions=F-F-F-R2.5-F-C&flop_actions=X&board=QsTs7h',
    },
    {
      name: 'reports - flop >actions',
      path: '/solutions',
      query:
        'preflop_actions=F-F-F-F-R3-R10-R21-C&gametype=Cash6m50zComplex&depth=100solution_type=gwiz&history_spot=8&flop_actions=X',
    },
    {
      name: 'reports - flop (starter - reports shortcuts)',
      path: '/solutions',
      query:
        'gametype=Cash6m500zBasic&depth=100&soltab=reports&history_spot=7&preflop_actions=F-F-F-R2.5-F-R11-C&gmfft_sort_key=0&gmfft_sort_order=desc',
    },
    {
      name: 'reports - turns',
      path: '/solutions',
      query:
        'gametype=Cash6m500zBasic&depth=100&soltab=reports&history_spot=10&preflop_actions=F-F-F-R2.5-F-C&flop_actions=X-R1.5-C&board=QsTs7h&turn_actions=X',
    },
    {
      name: 'MTT BUBBLE 3max',
      path: '/solutions',
      query:
        'gametype=MTTGeneral_ICM3m1000PTFT&depth=120.125&stacks=120.125-20.125-40.125&history_spot=0&soltab=strategy&gmfft_sort_key=0&gmfft_sort_order=desc&stratab=strategy&preflop_actions=R40',
    },
    {
      name: 'MTT BUBBLE 5max',
      path: '/solutions',
      query:
        'gametype=MTTGeneral_ICM5m1000PTFT&depth=10.125&stacks=10.125-50.125-40.125-30.125-20.125&history_spot=0&soltab=strategy&gmfft_sort_key=1&gmfft_sort_order=asc&preflop_actions=F-F-R2&stratab=strategy',
    },
    {
      name: 'MTT BUBBLE 9max',
      path: '/solutions',
      query:
        'gametype=MTTGeneral_ICM9m1000PTFT&depth=35.125&stacks=35.125-35.125-35.125-35.125-35.125-35.125-35.125-35.125-35.125&preflop_actions=F-F&history_spot=0&&stratab=strategy',
    },
    {
      name: 'MTT PKO BUBBLE 8max BOUNTY',
      path: '/solutions',
      query:
        'gametype=MTTGeneral_ICMPKO8m200PTPCT70&depth=58.125&stacks=58.125-62.125-34.125-66.125-42.125-38.125-54.125-46.125&history_spot=0&gmff_type=basic&gmfft_sort_key=0&gmfft_sort_order=desc&board=QsTs7h',
    },
    {
      name: 'TRAINER - MTT BUBBLE 3max - is_solution_end: true - prefillai btn',
      path: '/practice/trainer',
      query:
        '?gametype=MTTGeneral_ICM3m1000PTFT&depth=120.125&stacks=120.125-20.125-40.125&gmfft_sort_key=0&gmfft_sort_order=desc&preflop_actions=R2-F&history_spot=2&fh_start_spot=custom_spot&fh_hero=BB&fh_actions=SRP&fh_groups=22,33,44,55,66,77,88,99,AA,KK,QQ,JJ,TT,AKs,AKo,AQs,AJs,AQo,KQs,ATs,AJo,KJs,KQo,QJs,KTs,A9s,ATo,QTs,A8s,JTs,A7s,A5s,KJo,K9s,A4s,A6s,Q9s,A3s,T9s,QJo,J9s,A2s,KTo,A9o,K8s,QTo,K7s,JTo,Q8s,K6s,T8s,A8o,J8s,K5s,98s,A5o,A7o,K4s,K9o,Q7s,K3s,Q6s,A4o,T7s,A6o,K2s,J7s,Q9o,T9o,Q5s,97s,A3o,J9o,87s,Q4s,Q3s,A2o,K8o,76s,Q2s,J6s,T6s,J5s,65s,96s,86s,54s,K7o,J4s,Q8o,T8o,J3s,J8o,K6o,75s,98o,J2s,T5s,K5o,T4s,64s,53s,85s,95s,T3s,K4o,T2s,43s,Q7o,74s,K3o,Q6o,T7o,J7o,97o,63s,87o,K2o,52s,Q5o,93s,84s,94s,42s,92s,Q4o,32s,73s,76o,Q3o,65o,54o,86o,T6o,Q2o,J6o,96o,62s,J5o,83s,82s,J4o,75o,J3o,72s,64o,53o,J2o,85o,T5o,95o,T4o,43o,T3o,T2o,74o,63o,52o,42o,84o,93o,94o,92o,32o,73o,62o,82o,83o,72o&fh_trainer_tables=1&fh_trainer_mode=stop_end_of_hand&fh_trainer_game_mode=trainer_actions&fh_trainer_grouping=swv_grouping_none&fh_trainer_autoplay=0_sec&fh_trainer_game_speed=normal&fh_trainer_quick_result=on&fh_trainer_hero_range=on&fh_trainer_opponent_range=on&fh_trainer_equity_chart=on&fh_trainer_ranges_comparison=on&fh_trainer_hand_strength=on&fh_trainer_total_frequency=on&fh_trainer_category_hands=on&fh_trainer_category_draws=on&fh_trainer_hero_strategy=on&fh_trainer_rng_visible=on&fh_trainer_streak_visible=on',
    },
  ]

  return res
}

export { getMagicLinks }
